import { Component } from '@angular/core';
import { LoaderService } from '@shared/services/loader.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  title = 'Super-App-Forms';

  constructor(public _loaderService : LoaderService){}
  
}
